// P-PATHHOME-B — /play/mixed route.
//
// Mounts the real MixedSession (replaces the P-PATHHOME-A "Coming soon"
// stub). The session is composed from buildMixedSession (longest-gap
// secure/fluent picks per strand) and logs each attempt with
// sessionSource="path" + adaptiveReason="cross_strand" (the trail's
// Mixed marker — see src/lib/engine/trailState.ts comment).
// MA-1004 (R1): the same validated `seed` and `resume` as /play/session
// (sessionDeepLink.ts), used by MixedSession only when no checkpoint exists.

import { createFileRoute } from "@tanstack/react-router";
import { MixedSession } from "@/screens/MixedSession";
import { KidRouteError } from "@/components/RouterErrorFallback";
import { parseResumeParam, parseSeedParam } from "@/lib/engine/sessionDeepLink";

export const Route = createFileRoute("/play/mixed")({
  errorComponent: KidRouteError, // MA-107
  validateSearch: (search: Record<string, unknown>): { resume?: number; seed?: string } => ({
    resume: parseResumeParam(search.resume),
    seed: parseSeedParam(search.seed),
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { resume, seed } = Route.useSearch();
  return <MixedSession resumeAt={resume} seed={seed} />;
}
